<div class="help">
  <div class="help-actions">
    <h1 class="help-actions__title">{{ 'HELP.TITLE' | translate }}</h1>
    @if (_countrySig() === 'ES') {
      <div (click)="_spanishCall()" class="help-actions__item">
        {{ 'HELP.LINKS.CALL' | translate: { number: _spanishPhoneNumber } }}
      </div>
    } @else {
      <div (click)="_portugueseComercialCall()" class="help-actions__item">
        {{ 'HELP.LINKS.APOIO_CLIENTE' | translate }}
      </div>
      <div (click)="_portugueseOutagesCall()" class="help-actions__item">
        {{ 'HELP.LINKS.ASISTENCIA' | translate }}
      </div>
      <div (click)="_portugueseMeterReadingCall()" class="help-actions__item">
        {{ 'HELP.LINKS.READINGS' | translate }}
      </div>
    }
    <div (click)="_onContactUs()" class="help-actions__item">{{ 'HELP.LINKS.CONTACTUS' | translate }}</div>
    <div (click)="_goToFAQ()" class="help-actions__item">
      {{ 'HELP.LINKS.FAQ' | translate }}
    </div>
  </div>
</div>
